import { Controller } from 'stimulus';

const HIDE_AFTER_TIMEOUT = 3000;

class CartTooltipController extends Controller {
  connect() {
    this.originalText = this.textTarget.textContent.trim();
    this.toggleText(false);
  }

  show() {
    const hookElement = document.querySelector('.cart-tooltip-hook');

    if (hookElement) {
      this.element.style.right = `${window.innerWidth - hookElement.getBoundingClientRect().right}px`;
      this.element.style.top = `${hookElement.offsetTop + hookElement.offsetHeight}px`;
    }

    this.element.hidden = false;

    setTimeout(this.hide.bind(this), HIDE_AFTER_TIMEOUT);
  }

  hide() {
    this.toggleText(false);
    this.element.hidden = true;
  }

  toggleText(state) {
    this.textTarget.style.display = state ? 'block' : 'none';
  }

  updateTooltipText(title) {
    this.textTarget.textContent = this.originalText.replace('[product]', title);
  }

  attachProductVariantTitle(title) {
    this.updateTooltipText(title);
    this.toggleText(true);
  }
}

CartTooltipController.targets = [
  'text',
];

export default CartTooltipController;
